import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import { green } from '@material-ui/core/colors';
import {
  Grid,
  TextField,
  Link,
  FormHelperText,
  Checkbox,
  Typography
} from '@material-ui/core';
import Reaptcha from 'reaptcha';

import TermsAndConditions from '../Modals/TermsAndConditions'
import RegisterSnackBar from './components/RegisterSnackBar'
import CircularProgressButton from './components/CircularProgressButton'
import { getParameterByName } from '../../utils/common';
import LoadingIndicator from '../../components/LoadingIndicator';

// import clsx from 'clsx'; 
import './css/style.css';
  

// import { HORIZONTAL_LOGO as theLogo } from '../../constants';
import { RECAPTCHA_KEY, REGISTRATION_AUTO_CONFIRM, PRODUCT_SHORT_NAME } from '../../constants';
import schema from './SignupSchema';

const useStyles = makeStyles(theme => ({
  root: {
    // height: '100vh',
    minHeight: '100%',
  },
  grid: {
    height: '100%',
    alignCenter:'center'
  },
  quoteContainer: {

  },
  quote: {

    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/auth.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: 'white',
    fontWeight: 300
  },
  name: {
    marginTop: '8px',
    color: 'white'
  },
  bio: {
    color: 'white'
  },
  contentContainer: {},
  content: {
    height: '90%',
    // margin: 'auto',
    textAlign: 'center',
    maxWidth: '700px'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingBototm: '8px',
    paddingLeft: '8px',
    paddingRight: '8px'
  },
  logoImage: {
    marginLeft: '16px'
  },
  panelSpacer: {
    width: 1,
    height: '15vh',
    minHeight: 208,
},
  contentBody: {
    flexGrow: 1,
    display: 'flex', 
  },
  form: {
   // borderColor: '#00BFFF',
    // borderStyle: 'solid',
    // borderWidth: 'medium',
    borderRadius: '8px',
    textAlign: 'center',
    alignItems: 'center',
    position: 'relative',
    paddingTop: 15,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom:50,

    // background: '#fff'
  },
  title: {
    marginTop: '8px'
  },
  textField: {
    marginTop: '8px'
  },
  policy: {
    marginTop: '4px',
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  pageBody: {
    backgroundColor: '#000',
    height: '100%'
  },
  helpBlock: {
      margin: 24,
  }
}));


const SignUp = props => {
  const { history, updateUser, apiManager } = props;
  const isConfirmationPage = getParameterByName('confirmation');
  const [confirmCode, setConfirmCode] = React.useState('');
 
  const data = props;

  const [isModalOpen, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [isSuccessfull, setSuccess] = React.useState(false);
  const [newUser, setNewUser] = React.useState(false);
  const classes = useStyles();
//   const timer = React.useRef();
//   const buttonClassname = clsx({
//     [classes.buttonSuccess]: isSuccessfull,
//   });
  const [recaptchaVerified, setRecaptcha] = React.useState(false);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
    },
    touched: {},
    errors: {},
    isSuccessfull: false
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleConfirmCodeInput = event => {
    event.persist();
    setConfirmCode(event.target.value);
  };
  
  const validateForm = () => {

    if ( !recaptchaVerified
        || !formState.values.email
        || !formState.values.emailAgain
        || !formState.values.firstName
        || !formState.values.lastName  
        || !formState.values.address1
        || !formState.values.city
        || !formState.values.state
        || !formState.values.country
        || !formState.values.postalCode
        || !formState.values.phone
        || !formState.values.policy  
        || !formState.values.password 
        || !formState.values.confirm) {
        return false;
    }
    
    // ok, they're all filled. check for valid
    if (formState.errors.email
        || formState.errors.emailAgain
        || formState.errors.firstName
        || formState.errors.lastName  
        || formState.errors.address1
        || formState.errors.city
        || formState.errors.state
        || formState.errors.country
        || formState.errors.postalCode
        || formState.errors.phone
        || formState.errors.policy  
        || formState.errors.password 
        || formState.errors.confirm) {
        return false;
    }

    // last check.. is confirm === password && email === emailAgain
    if( (formState.values.password !== formState.values.confirm) || (formState.values.email !== formState.values.emailAgain)) {
        return false;
    }

    return true;

  }
  
  const onVerify = recaptchaResponse => {
    setRecaptcha(true);
  };
  
  const confirmationClick = async (event) => {
    event.preventDefault();   
    try {
        setLoading(true);
  
       // const result = await axios.post(url, formState.values)

       const result = await apiManager.validateCode(formState.values.email || 'eddie@curve10.com', confirmCode, formState.values.password || 'Password01!');
        props.userHasAuthenticated(true);
        setLoading(false);

        if(result && result.data && result.data.email){ 
        
         setNewUser(result);
          localStorage.setItem('token', result.data.token);
          history.push('/home'); 
        }
        else { 
          setSuccess(false);
          setLoading(false);
          const messageParts = result.message.split(':');
          setMessage(`${messageParts[1]}: ${messageParts[2]}`);
        }
        
        
        
      }
      catch(ex){
        console.log(ex);
        setFormState(formState => ({
          ...formState,
          error: ex
        }));
        setSuccess(false);
        setLoading(false);
        //setMessage(ex);
  
      }
    }
   
  const registerClick = async (event) => {
    event.preventDefault();   
debugger;
    if(!validateForm()){
        setSuccess(false);
        setLoading(false);
        setMessage(`Incomplete or invalid information, please review and try again`);
        setOpen(true)
    }
    else {
    
    setLoading(false);
   
    try {
      setLoading(true);
      setSuccess(false);

      const params = formState.values;
      params.email = formState.values.email.toLowerCase();
      params.referral = localStorage.getItem('referrerURL');
      params.subExp = Math.round(new Date().getTime() / 1000).toString(); // expires today
      params.isSubscribed = false;
      params.organization = PRODUCT_SHORT_NAME;
      params.role = "user";

      debugger;
      const result = await apiManager.signUp(params);
      setLoading(false);
      debugger;

  
      if(result && result.user && result.user.username){ 

        
 
       setNewUser(result);
        localStorage.setItem('token', result.userSub);
        localStorage.setItem("uid", params.email );
        localStorage.setItem("pid", params.password );

        debugger;
        const payload = {
          "username": result.user.username, 
          "firstname": formState.values.firstName, 
          "lastname": formState.values.lastName, 
          "userSub": result.userSub
        }
          
        updateUser(payload);
        
        debugger;
        if(true || REGISTRATION_AUTO_CONFIRM) {

            params.cognitoId = result.userSub;
            await apiManager.confirmUser(params);
            // Authenticate User via Amplify otherwise it all falls apart
            await apiManager.signIn(params.email, params.password);
            props.appProps.userHasAuthenticated(true);
            setTimeout(() => {
              setLoading(false);
              history.push('/home');   
            }, 5000);
            return;
        } else {
            history.push('/verification'); 
        }
      }
      else { 
       
        setSuccess(false);
        setLoading(false);
 
        setMessage(`Error: ${result.message}`);
      }
      
      
      
    }
    catch(ex){
 
      console.log(ex);
      setFormState(formState => ({
        ...formState,
        error: ex
      }));
      setSuccess(false);
      setLoading(false);
      //setMessage(ex);

    }
    setOpen(true)
  }
  };

  const closeModal = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false)
  }

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;


  const renderConfirmationForm = () => {
    const scrollToElement = document.getElementById('panelTop');
    scrollToElement.scrollIntoView({ behavior: 'smooth' });
        return (
          <div style={{width: '100%', marginTop: '20vh'}}>
               <LoadingIndicator />
          </div>
          // <form>
          //     <div style={{fontWeight: 500, fontSize: 18, marginBottom: 48}}>Enter Your Confirmation Code</div>
          //     <div className={classes.helpBlock}>To complete your registration, please check your email for the code and enter it below:</div>
          //     <TextField 
          //       id="outlined-basic" 
          //       label="Confirmation Code" 
          //       variant="outlined" 
          //       value={confirmCode || ''}
          //       onChange={handleConfirmCodeInput}
          //       />
          //    <CircularProgressButton 
          //       label={'Submit Code'}
          //       isLoading={isLoading} 
          //       disabled={confirmCode.length < 4}
          //       onClick={confirmationClick} ></CircularProgressButton>
          // </form>
        );
      }
  
      const renderSignUpForm = () => {

        return(
            <div>
            <div style={{fontWeight: 400, marginTop: 24, marginBottom: 28, fontSize: 18}}>
            <b>Welcome to the Regen Ag Online Series enrollment portal</b>—your gateway to virtual Regen Ag course instruction for regenerative agriculture on-farm school experience. 

<br /><br/>Please enroll now (all fields required):
            </div>
            <TextField
            className={classes.textField}
            error={hasError('firstName')}
            fullWidth
            helperText={
              hasError('firsName') ? formState.errors.firstName[0] : null
            }
            label="First name"
            name="firstName"
            onChange={handleChange}
            type="text"
            value={formState.values.firstName || ''}
            variant="standard"
          />
          <TextField
            className={classes.textField}
            error={hasError('lastName')}
            fullWidth
            helperText={
              hasError('lastName') ? formState.errors.lastName[0] : null
            }
            label="Last name"
            name="lastName"
            onChange={handleChange}
            type="text"
            value={formState.values.lastName || ''}
            variant="standard"
          />
            <TextField
            className={classes.textField}
            error={hasError('email')}
            fullWidth
            helperText={
              hasError('email') ? formState.errors.email[0] : null
            }
            label="Email address"
            name="email"
            onChange={handleChange}
            type="text"
            value={formState.values.email || ''}
            variant="standard"
            inputProps={{
                autocomplete: 'new-email',
                form: {
                  autocomplete: 'off',
                },
              }}
          />
         <TextField
            className={classes.textField}
            error={formState.values.emailAgain && formState.values.email !== formState.values.emailAgain}
            fullWidth
            helperText={
                formState.values.emailAgain && formState.values.email !== formState.values.emailAgain ? 'Emails do not match' : null
            }
            label="Repeat Email"
            name="emailAgain"
            onChange={handleChange}
            type="text"
            value={formState.values.emailAgain || ''}
            variant="standard"
            inputProps={{
                autocomplete: 'new-emailAgain',
                form: {
                  autocomplete: 'off',
                },
              }}
          />
         <TextField
            className={classes.textField}
            error={hasError('phone')}
            fullWidth
            helperText={
              hasError('phone') ? formState.errors.phone[0] : null
            }
            label="Phone Number"
            name="phone"
            onChange={handleChange}
            type="text"
            value={formState.values.phone || ''}
            variant="standard"
          />
         <TextField
            className={classes.textField}
            error={hasError('address1')}
            fullWidth
            helperText={
              hasError('address1') ? formState.errors.address1[0] : null
            }
            label="Address Line 1"
            name="address1"
            onChange={handleChange}
            type="text"
            value={formState.values.address1 || ''}
            variant="standard"
          />
          <TextField
            className={classes.textField}
            error={hasError('address2')}
            fullWidth
            helperText={
              hasError('address2') ? formState.errors.address2[0] : null
            }
            label="Address Line 2 (Optional)"
            name="address2"
            onChange={handleChange}
            type="text"
            value={formState.values.address2 || ''}
            variant="standard"
          />
        <TextField
            className={classes.textField}
            error={hasError('city')}
            fullWidth
            helperText={
              hasError('city') ? formState.errors.city[0] : null
            }
            label="City"
            name="city"
            onChange={handleChange}
            type="text"
            value={formState.values.city || ''}
            variant="standard"
          />
            <TextField
            className={classes.textField}
            error={hasError('state')}
            fullWidth
            helperText={
              hasError('state') ? formState.errors.state[0] : null
            }
            label="State/Province"
            name="state"
            onChange={handleChange}
            type="text"
            value={formState.values.state || ''}
            variant="standard"
          />
        <TextField
            className={classes.textField}
            error={hasError('country')}
            fullWidth
            helperText={
              hasError('country') ? formState.errors.country[0] : null
            }
            label="Country"
            name="country"
            onChange={handleChange}
            type="text"
            value={formState.values.country || ''}
            variant="standard"
          />
        <TextField
            className={classes.textField}
            error={hasError('postalCode')}
            fullWidth
            helperText={
              hasError('postalCode') ? formState.errors.postalCode[0] : null
            }
            label="ZIP/Postal Code"
            name="postalCode"
            onChange={handleChange}
            type="text"
            value={formState.values.postalCode || ''}
            variant="standard"
          />
         
          <TextField
            className={classes.textField}
            error={hasError('password')}
            fullWidth
            helperText={
              hasError('password') ? formState.errors.password[0] : null
            }
            label="Password"
            name="password"
            onChange={handleChange}
            type="password"
            value={formState.values.password || ''}
            variant="standard"
            helperText="minimum 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character"
            inputProps={{
                autocomplete: 'new-password',
                form: {
                  autocomplete: 'off',
                },
              }}
          />
           <TextField
            className={classes.textField}
            error={formState.values.confirm && formState.values.password !== formState.values.confirm}
            fullWidth
            // helperText={
            //   hasError('confirm') ? formState.errors.confirm[0] : null
            // }
            helperText={
                formState.values.confirm && formState.values.password !== formState.values.confirm ? 'Passwords do not match' : null
            }
            label="Confirm Password"
            name="confirm"
            onChange={handleChange}
            type="password"
            value={formState.values.confirm || ''}
            variant="standard"
            inputProps={{
                autocomplete: 'new-confirm',
                form: {
                  autocomplete: 'off',
                },
              }}
          /> 
          <div className={classes.policy}>
            <Checkbox
                  error={hasError('policy')}
              checked={formState.values.policy || false}
              className={classes.policyCheckbox}
              color="primary"
              name="policy"
              onChange={handleChange}
            />
            <TermsAndConditions />
          </div>
          {hasError('policy') && (
            <FormHelperText error>
              {formState.errors.policy[0]}
            </FormHelperText>
          )}
           {/* <div style={{width: 300, margin: '20px auto'}} class="g-recaptcha" data-sitekey={RECAPTCHA_KEY}></div> */}
           <div id='recaptcha' style={{width: 300, margin: '20px auto'}}>
           <Reaptcha sitekey={RECAPTCHA_KEY} onVerify={onVerify} />

           </div>

          <CircularProgressButton 
            label={'Register'} isLoading={isLoading} 
            onClick={registerClick} 
            disabled={!validateForm()}
            >
            </CircularProgressButton>
          <RegisterSnackBar isOpen={isModalOpen} isSuccessfull={isSuccessfull} message={message} closeModal={closeModal}/>
          <Typography
            color="textSecondary"
            variant="body1"
            style={{marginTop:'15px'}}
          >
            Have an account?{' '}
            <Link
              component={RouterLink}
              to="/signin"
              variant="h7"
            >
              Sign In
            </Link>
          </Typography>
          </div>
        )
      }

  return (
    <div className={classes.root}>
      <Grid
        className={classes.grid}
        container
        direction="column"
        alignItems="center"
        justify="center"
      > 
        <Grid
          className={classes.content}
          item
          lg={7}
          xs={12}
        >
          <div className={classes.content}> 
            <div id='panelTop' className={'panelSpacer'} />
            <div className={classes.contentBody}>
              <form
                className={classes.form} 
              >
                <Typography
                  color="textSecondary"
                  align="center"
                  paragraph
                >
                    {/* <img src={theLogo} 
                      alt="Soil Health Academy.com" 
                      width="200px" 
                      align='middle' 
                      className='course-logo'
                      />      */}
                </Typography>
             
                {newUser || isConfirmationPage
                    ? renderConfirmationForm()
                    : renderSignUpForm()
                }
              </form>
            </div>
          </div>
          
        </Grid>
      </Grid>
    </div>
  );
};

SignUp.propTypes = {
  history: PropTypes.object,
  updateUser: PropTypes.func
};

export default withRouter(SignUp);
